// Action types
export const FETCH_DEFAULTS = 'zen/DefaultLocations/FETCH_DEFAULTS';
export const FETCH_DEFAULTS_SUCCEEDED = 'zen/DefaultLocations/FETCH_DEFAULTS_SUCCEEDED';
export const FETCH_DEFAULTS_FAILED = 'zen/DefaultLocations/FETCH_DEFAULTS_FAILED';
export const CREATE_DEFAULT = 'zen/DefaultLocations/CREATE_DEFAULT';
export const CREATE_DEFAULT_SUCCEEDED = 'zen/DefaultLocations/CREATE_DEFAULT_SUCCEEDED';
export const CREATE_DEFAULT_FAILED = 'zen/DefaultLocations/CREATE_DEFAULT_FAILED';
export const PATCH_DEFAULT = 'zen/DefaultLocations/PATCH_DEFAULT';
export const PATCH_DEFAULT_SUCCEEDED = 'zen/DefaultLocations/PATCH_DEFAULT_SUCCEEDED';
export const PATCH_DEFAULT_FAILED = 'zen/DefaultLocations/PATCH_DEFAULT_FAILED';
export const DELETE_DEFAULT = 'zen/DefaultLocations/DELETE_DEFAULT';
export const DELETE_DEFAULT_SUCCEEDED = 'zen/DefaultLocations/DELETE_DEFAULT_SUCCEEDED';
export const DELETE_DEFAULT_FAILED = 'zen/DefaultLocations/DELETE_DEFAULT_FAILED';
export const SET_PLATFORM_FILTER = 'zen/DefaultLocations/SET_PLATFORM_FILTER';
export const SET_PAGE = 'zen/DefaultLocations/SET_PAGE';
export const SET_PAGE_SIZE = 'zen/DefaultLocations/SET_PAGE_SIZE';
export const CLEAR_STATE = 'zen/DefaultLocations/CLEAR_STATE';
export const SHOW_CREATE_MODAL = 'zen/DefaultLocations/SHOW_CREATE_MODAL';
export const HIDE_CREATE_MODAL = 'zen/DefaultLocations/HIDE_CREATE_MODAL';
export const SHOW_EDIT_MODAL = 'zen/DefaultLocations/SHOW_EDIT_MODAL';
export const HIDE_EDIT_MODAL = 'zen/DefaultLocations/HIDE_EDIT_MODAL';
export const SHOW_DELETE_MODAL = 'zen/DefaultLocations/SHOW_DELETE_MODAL';
export const HIDE_DELETE_MODAL = 'zen/DefaultLocations/HIDE_DELETE_MODAL';
export const LOOKUP_LOCATION_FORWARD = 'zen/DefaultLocations/LOOKUP_LOCATION_FORWARD';
export const LOOKUP_LOCATION_REVERSE = 'zen/DefaultLocations/LOOKUP_LOCATION_REVERSE';
export const LOOKUP_LOCATION_SUCCEEDED = 'zen/DefaultLocations/LOOKUP_LOCATION_SUCCEEDED';
export const LOOKUP_LOCATION_FAILED = 'zen/DefaultLocations/LOOKUP_LOCATION_FAILED';
export const CLEAR_LOOKUP = 'zen/DefaultLocations/CLEAR_LOOKUP';

const initialState = {
  locations: [],
  total: 0,
  isFetching: false,
  error: null,
  platform: 'twitter',
  currentPage: 1,
  pageSize: 50,
  // CRUD status
  isCreating: false,
  createError: null,
  isPatching: false,
  patchError: null,
  isDeleting: false,
  deleteError: null,
  // Modals
  showCreateModal: false,
  showEditModal: false,
  showDeleteModal: false,
  selectedLocation: null,
  // Carmen lookup (forward + reverse share results buffer)
  lookupResults: [],
  isLookingUp: false,
  lookupError: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_DEFAULTS:
      return {
        ...state,
        isFetching: true,
        error: null,
      };

    case FETCH_DEFAULTS_SUCCEEDED:
      return {
        ...state,
        isFetching: false,
        locations: action.payload.locations,
        total: action.payload.total,
      };

    case FETCH_DEFAULTS_FAILED:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    case SET_PLATFORM_FILTER:
      return {
        ...state,
        platform: action.payload,
        currentPage: 1,
      };

    case SET_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };

    case SET_PAGE_SIZE:
      return {
        ...state,
        pageSize: action.payload,
        currentPage: 1,
      };

    case CREATE_DEFAULT:
      return {
        ...state,
        isCreating: true,
        createError: null,
      };

    case CREATE_DEFAULT_SUCCEEDED:
      return {
        ...state,
        isCreating: false,
        // keep the modal open when the user clicked "Save & Add Another"
        showCreateModal: !!(action.payload && action.payload.keepModalOpen),
      };

    case CREATE_DEFAULT_FAILED:
      return {
        ...state,
        isCreating: false,
        createError: action.payload,
      };

    case PATCH_DEFAULT:
      return {
        ...state,
        isPatching: true,
        patchError: null,
      };

    case PATCH_DEFAULT_SUCCEEDED: {
      const updated = action.payload;
      const updatedId = updated && updated._id;
      const locations = updatedId
        ? state.locations.map((row) => (row._id === updatedId ? updated : row))
        : state.locations;
      return {
        ...state,
        isPatching: false,
        showEditModal: false,
        locations,
      };
    }

    case PATCH_DEFAULT_FAILED:
      return {
        ...state,
        isPatching: false,
        patchError: action.payload,
      };

    case DELETE_DEFAULT:
      return {
        ...state,
        isDeleting: true,
        deleteError: null,
      };

    case DELETE_DEFAULT_SUCCEEDED:
      return {
        ...state,
        isDeleting: false,
        showDeleteModal: false,
      };

    case DELETE_DEFAULT_FAILED:
      return {
        ...state,
        isDeleting: false,
        deleteError: action.payload,
      };

    case SHOW_CREATE_MODAL:
      return {
        ...state,
        showCreateModal: true,
        createError: null,
      };

    case HIDE_CREATE_MODAL:
      return {
        ...state,
        showCreateModal: false,
      };

    case SHOW_EDIT_MODAL:
      return {
        ...state,
        showEditModal: true,
        selectedLocation: action.payload,
        patchError: null,
      };

    case HIDE_EDIT_MODAL:
      return {
        ...state,
        showEditModal: false,
        selectedLocation: null,
      };

    case SHOW_DELETE_MODAL:
      return {
        ...state,
        showDeleteModal: true,
        selectedLocation: action.payload,
      };

    case HIDE_DELETE_MODAL:
      return {
        ...state,
        showDeleteModal: false,
        selectedLocation: null,
      };

    case LOOKUP_LOCATION_FORWARD:
    case LOOKUP_LOCATION_REVERSE:
      return {
        ...state,
        isLookingUp: true,
        lookupError: null,
        lookupResults: [],
      };

    case LOOKUP_LOCATION_SUCCEEDED:
      return {
        ...state,
        isLookingUp: false,
        lookupResults: action.payload || [],
      };

    case LOOKUP_LOCATION_FAILED:
      return {
        ...state,
        isLookingUp: false,
        lookupError: action.payload,
        lookupResults: [],
      };

    case CLEAR_LOOKUP:
      return {
        ...state,
        lookupResults: [],
        isLookingUp: false,
        lookupError: null,
      };

    case CLEAR_STATE:
      return initialState;

    default:
      return state;
  }
}

// Action creators
export function fetchDefaults() {
  return {
    type: FETCH_DEFAULTS,
  };
}

export function fetchDefaultsSucceeded(locations, total) {
  return {
    type: FETCH_DEFAULTS_SUCCEEDED,
    payload: { locations, total },
  };
}

export function fetchDefaultsFailed(error) {
  return {
    type: FETCH_DEFAULTS_FAILED,
    payload: error,
  };
}

export function createDefault(data, options = {}) {
  return {
    type: CREATE_DEFAULT,
    payload: data,
    meta: { keepModalOpen: !!options.keepModalOpen },
  };
}

export function createDefaultSucceeded(keepModalOpen = false) {
  return {
    type: CREATE_DEFAULT_SUCCEEDED,
    payload: { keepModalOpen },
  };
}

export function createDefaultFailed(error) {
  return {
    type: CREATE_DEFAULT_FAILED,
    payload: error,
  };
}

export function patchDefault(id, updates) {
  return {
    type: PATCH_DEFAULT,
    payload: { id, updates },
  };
}

export function patchDefaultSucceeded(updatedLocation) {
  return {
    type: PATCH_DEFAULT_SUCCEEDED,
    payload: updatedLocation,
  };
}

export function patchDefaultFailed(error) {
  return {
    type: PATCH_DEFAULT_FAILED,
    payload: error,
  };
}

export function deleteDefault(id) {
  return {
    type: DELETE_DEFAULT,
    payload: id,
  };
}

export function deleteDefaultSucceeded() {
  return {
    type: DELETE_DEFAULT_SUCCEEDED,
  };
}

export function deleteDefaultFailed(error) {
  return {
    type: DELETE_DEFAULT_FAILED,
    payload: error,
  };
}

export function setPlatformFilter(platform) {
  return {
    type: SET_PLATFORM_FILTER,
    payload: platform,
  };
}

export function setPage(page) {
  return {
    type: SET_PAGE,
    payload: page,
  };
}

export function setPageSize(size) {
  return {
    type: SET_PAGE_SIZE,
    payload: size,
  };
}

export function clearState() {
  return {
    type: CLEAR_STATE,
  };
}

export function showCreateModal() {
  return {
    type: SHOW_CREATE_MODAL,
  };
}

export function hideCreateModal() {
  return {
    type: HIDE_CREATE_MODAL,
  };
}

export function showEditModal(location) {
  return {
    type: SHOW_EDIT_MODAL,
    payload: location,
  };
}

export function hideEditModal() {
  return {
    type: HIDE_EDIT_MODAL,
  };
}

export function showDeleteModal(location) {
  return {
    type: SHOW_DELETE_MODAL,
    payload: location,
  };
}

export function hideDeleteModal() {
  return {
    type: HIDE_DELETE_MODAL,
  };
}

export function lookupLocationForward(location) {
  return {
    type: LOOKUP_LOCATION_FORWARD,
    payload: { location },
  };
}

export function lookupLocationReverse(latitude, longitude) {
  return {
    type: LOOKUP_LOCATION_REVERSE,
    payload: { latitude, longitude },
  };
}

export function lookupLocationSucceeded(results) {
  return {
    type: LOOKUP_LOCATION_SUCCEEDED,
    payload: results,
  };
}

export function lookupLocationFailed(error) {
  return {
    type: LOOKUP_LOCATION_FAILED,
    payload: error,
  };
}

export function clearLookup() {
  return {
    type: CLEAR_LOOKUP,
  };
}
